export default "__VITE_ASSET__aqH0Mcg0__"